import RegistroTDBusiness from "@/business/indicadores/RegistroTDBusiness.js";
import RegistroPJBusiness from "@/business/indicadores/RegistroPJBusiness.js";
import DominioBusiness from "@/business/protocolo/DominioBusiness.js";
import RegraCustasBusiness from "@/business/RegraCustasBusiness.js";
import TabelaCustaBusiness from "@/business/TabelaCustaBusiness.js";
import VueBusiness from "@/business/VueBusiness.js";
import ProtocoloBusiness from "@/business/protocolo/ProtocoloBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import RegistroAuxiliarBusiness from "@/business/indicadores/RegistroAuxiliarBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import CaixaBusiness from "@/business/crud/CaixaBusiness";
import CategoriaBusiness from "@/business/crud/CategoriaBusiness";
import EtapaBusiness from "@/business/crud/EtapaBusiness";
import ChecklistBusiness from "@/business/crud/ChecklistBusiness";
import LayoutImpressaoBusiness from "@/business/crud/LayoutImpressaoBusiness";
import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness";
import ConfiguracaoBusiness from "@/business/ConfiguracaoBusiness";
import TipoDocumentoBusiness from "@/business/crud/TipoDocumentoBusiness";
import ListaBusiness from "@/business/crud/ListaBusiness";
import SiscoafBusiness from "@/business/protocolo/SiscoafBusiness";
import UsuarioBusiness from "@/business/crud/UsuarioBusiness";
import NotificacaoBusiness from "@/business/notificacao/NotificacaoBusiness";
import IndicadorAbstractService from "@/business/indicadores/IndicadorAbstractService";
import RepasseBusiness from "@/business/crud/RepasseBusiness";
import NaturezaBusiness from "@/business/crud/NaturezaBusiness";
import EnderecoBusiness from "@/business/EnderecoBusiness";
import AuditoriaBusiness from "@/business/AuditoriaBusiness";
import NotaFiscalBusiness from "@/business/financeiro/NotaFiscalBusiness";
import TagBusiness from "@/business/TagBusiness";
import PapelBusiness from "@/business/PapelBusiness";
import FragmentoBusiness from "@/business/crud/FragmentoBusiness";
import TipoInconformidadeBusiness from "@/business/crud/TipoInconformidadeBusiness";
import TipoBemBusiness from "@/business/crud/TipoBemBusiness";
import Utils from "@/commons/Utils";
import OficioBusiness from "@/business/oficio/OficioBusiness";
import DocumentacaoBusiness from "@/business/indicadores/DocumentacaoBusiness";

export default {
  default: [
    { label: "Identificador", key: "id" },
    { label: "Cadastro", key: "cadastro", type: "datetime" },
    { label: "Atualização", key: "atualizacao", type: "datetime" },
    { label: "Registro Ativo", key: "ativo", type: "boolean" },
    { label: "Legado", key: "legado", type: "boolean" },
    { label: "Nome", key: "nome" },
    {
      label: "Domínio",
      key: "dominio",
      formatter: async (value) => {
        switch (value) {
          case "PROTOCOLO_RI":
            return "Protocolo";
          case "CERTIDAO_RI":
            return "Certidão";
          case "OFICIO":
            return "Ofício";
          case "OCORRENCIA":
            return "Ocorrência";
          case "NOTIFICACAO":
            return "Notificação";
          case "PERSONALIZADO":
            return "Tarefa";
        }
      }
    }
  ],

  // ==============
  // Função principal
  // ==============
  async getFormatters(auditoria) {
    const { entidade, dominio } = auditoria;
    console.debug(`--------- NOVO Formatters: ${entidade} - dominio: ${dominio}`);

    switch (entidade) {
      case "ATRIBUICAO": return this.getFormattersAtribuicao();
      case "DEPARTAMENTO": return this.getFormattersDepartamento();
      case "GRUPO_PERMISSAO": return this.getFormattersGrupoPermissao();
      case "USUARIO": return this.getFormattersUsuario();
      case "LISTA": return this.getFormattersLista();
      case "CHECKLIST": return await this.getFormattersChecklist();
      case "FRAGMENTO": return this.getFormattersFragmento();
      case "MODELO_TEXTUAL": return this.getFormattersModeloTextual();
      case "LAYOUT_IMPRESSAO": return this.getFormattersLayoutImpressao();
      case "NATUREZA": return dominio === "PERSONALIZADO" ? this.getFormattersNaturezaDominioPersonalizado() : this.getFormattersNatureza();
      case "TIPO_DOCUMENTO": return this.getFormattersTipoDocumento();
      case "REPASSE": return this.getFormattersRepasse();
      case "FERIADO": return this.getFormattersFeriado();
      case "TAG": return await this.getFormattersTag();
      case "PAPEL": return await this.getFormattersPapel();
      case "CAIXA": return this.getFormattersCaixa();
      case "CATEGORIA": return this.getFormattersCategoria();
      case "FILA_ATENDIMENTO": return this.getFormattersFilaAtendimento();
      case "ANEXO_SISTEMA": return this.getFormattersAnexoSistema();
      case "CONFIGURACAO": return await this.getFormattersConfiguracao();
      case "AGENDAMENTOS_TAREFAS": return this.getFormattersAgendamentosTarefas();
      case "FOLHA_PAGAMENTO": return this.getFormattersFolhaPagamento(auditoria);
      case "FOLHA_SEGURANCA": return this.getFormattersFolhaSeguranca();
      case "TIPO_SERVICO": return await this.getFormattersTipoServico(dominio);
      case "ETAPA": return await this.getFormattersEtapa(dominio);
      case "TAREFA": return this.getFormattersTarefa();
      case "ATIVIDADE_CHECKLIST": return this.getFormattersAtividadeChecklist();
      case "DIGITALIZACAO_CERTIDAO":
      case "DIGITALIZACAO_CERTIDAO_AUXILIAR":
      case "DIGITALIZACAO_DOCUMENTACAO":
      case "DIGITALIZACAO_DOCUMENTACAO_AUXILIAR":
      case "DIGITALIZACAO_INDICADOR_REAL":
      case "DIGITALIZACAO_INDICADOR_REAL_AUXILIAR":
      case "DIGITALIZACAO_NOTIFICACAO":
      case "DIGITALIZACAO_NOTIFICACAO_AUXILIAR":
      case "DIGITALIZACAO_OCORRENCIA":
      case "DIGITALIZACAO_OCORRENCIA_AUXILIAR":
      case "DIGITALIZACAO_OFICIO":
      case "DIGITALIZACAO_OFICIO_AUXILIAR":
      case "DIGITALIZACAO_PROTOCOLO":
      case "DIGITALIZACAO_PROTOCOLO_AUXILIAR":
      case "DIGITALIZACAO_REGISTRO_AUXILIAR":
      case "DIGITALIZACAO_REGISTRO_AUXILIAR_AUXILIAR":
      case "DIGITALIZACAO_INDICADOR":
      case "DIGITALIZACAO_INDICADOR_AUXILIAR":
        return this.getFormattersDigitalizacao();

      case "INDICADOR_REAL_EXTERNO":
        return this.getFormattersIndicadorRealExterno();

      case "INDICADOR_REAL":
      case "INDICADOR_REAL_HISTORICO":
        return this.getFormattersIndicadorReal();

      case "INDICADOR_PESSOAL":
      case "INDICADOR_PESSOAL_VERSAO":
        return this.getFormattersIndicadorPessoal(auditoria);

      case "INDICADOR_PESSOAL_SOCIO":
        return this.getFormattersIndicadorPessoalSocio();

      case "PROTOCOLO":
        return this.getFormattersProtocolo(dominio);

      case "PROTOCOLO_DOCUMENTO":
        return this.getFormattersProtocoloDocumento();

      case "LIVRO_PROTOCOLO":
        return this.getFormattersLivroProtocolo();

      case "PROTOCOLO_REPASSE":
        return this.getFormattersProtocoloRepasse();

      case "REGISTRO_AUXILIAR":
        return this.getFormattersRegistroAuxiliar(auditoria);

      case "PROTOCOLO_ATIVIDADE":
        return this.getFormattersProtocoloAtividade();

      case "PROTOCOLO_FINANCEIRO":
      case "EINTIMACAO_CENTRAL_CSV":
        return await this.getFormattersProtocoloFinanceiro(auditoria);

      case "PROTOCOLO_FINANCEIRO_AJUSTE":
        return this.getFormattersProtocoloFinanceiroAjuste();

      case "NOTIFICACAO":
        return this.getFormattersNotificacao();

      case "OCORRENCIA":
        return this.getFormattersOcorrencia();

      case "OFICIO":
        return this.getFormattersOficio();

      case "ATO":
      case "PROTOCOLO_CUSTA_ADICIONAL":
      case "PROTOCOLO_PRENOTACAO":
      case "CERTIDAO":
        return await this.getFormattersAtos(auditoria);

      case "RECEITA_EXTERNA_ITEM":
        return this.getFormattersReceitaExternaItem();

      case "ODIN_CREDITO_EXTRA":
        return this.getFormattersCreditoExtraOdin();

      case "LANCAMENTO":
      case "TRANSFERENCIA":
        return this.getFormattersLancamento();

      case "SELO":
        return this.getFormattersSelo();

      case "LOTE_ENVIO_SELO":
        return this.getFormattersLoteEnvioSelo();

      case "SISCOAF":
        return this.getFormattersSiscoaf();

      case "DAJE":
        return this.getFormattersDaje();

      case "INDISPONIBILIDADE":
        return this.getFormattersIndisponibilidade();

      case "INDICADOR":
      case "TABELIONATO":
      case "ESCRITURA":
      case "PROCURACAO":
      case "SUBSTABELECIMENTO":
      case "TESTAMENTO":
      case "ATA_NOTARIAL":
      case "ABONO_SINAL_PUBLICO":
      case "BEM_MOVEL":
      case "REGISTRO_INTEGRAL":
      case "REGISTRO_CONSERVACAO":
      case "REGISTRO_INSCRICAO":
      case "LIVRO_PROTOCOLO_REGERAR":
      case "LIVRO_A":
      case "LIVRO_B":
      case "LIVRO_C":
        return this.getFormattersRegistroTD();

      case "INCONFORMIDADE":
        return this.getFormattersInconformidade();

      case "ENVIO_EMAIL":
        return this.getCamposEnvioEmail();

      case "ANOTACAO":
      case "NOTIFICACAO_ANOTACAO":
      case "PROTOCOLO_ANOTACAO":
      case "OCORRENCIA_ANOTACAO":
      case "TAREFA_ANOTACAO":
      case "OFICIO_ANOTACAO":
        return this.getCamposAnotacao();

      case "ARQUIVO_MORTO_PASTA":
        return this.getFormattersArquivoMortoPasta();

      case "ANEXO_ARQUIVO_MORTO":
        return this.getCamposArquivoMorto();

      case "ANEXO_ASSINATURA_USUARIO":
      case "ANEXO_ATO":
      case "ANEXO_CERTIDAO":
      case "ANEXO_DIGITALIZACAO_CERTIDAO":
      case "ANEXO_DIGITALIZACAO_DOCUMENTACAO":
      case "ANEXO_DIGITALIZACAO_INDICADOR_PESSOAL":
      case "ANEXO_DIGITALIZACAO_INDICADOR_REAL":
      case "ANEXO_DIGITALIZACAO_NOTIFICACAO":
      case "ANEXO_DIGITALIZACAO_OCORRENCIA":
      case "ANEXO_DIGITALIZACAO_OFICIO":
      case "ANEXO_DIGITALIZACAO_PROTOCOLO":
      case "ANEXO_DIGITALIZACAO_REGISTRO_AUXILIAR":
      case "ANEXO_DIGITALIZACAO_INDICADOR":
      case "ANEXO_DOCUMENTACAO":
      case "ANEXO_INDICADOR_DOCUMENTO":
      case "ANEXO_INDICADOR_PESSOAL":
      case "ANEXO_INDICADOR_PESSOAL_CAPTURA":
      case "ANEXO_INDICADOR_PESSOAL_CAPTURA_BIOMETRIA":
      case "ANEXO_INDICADOR_PESSOAL_CAPTURA_ASSINATURA":
      case "ANEXO_INDICADOR_REAL":
      case "ANEXO_LANCAMENTO":
      case "ANEXO_NOTIFICACAO":
      case "ANEXO_NOTIFICACAO_DILIGENCIA":
      case "ANEXO_OCORRENCIA":
      case "ANEXO_TAREFA":
      case "ANEXO_OFICIO":
      case "ANEXO_PROTOCOLO":
      case "ANEXO_PROTOCOLO_DOCUMENTO":
      case "ANEXO_REGISTRO_AUXILIAR":
      case "ANEXO_INDICADOR":
      case "ANEXO_IMPRESSAO_INDICADOR":
      case "ANEXO_RECIBO_PROTOCOLO":
      case "ANEXO_NOTA_FISCAL":
        return this.getCamposAnexo();

      case "NOTA_FISCAL":
        return this.getFormattersNotaFiscal();

      case "ANEXO_COMPROVANTE_ISENCAO":
        return this.getCamposAnexo();

      case "SENHA_ATENDIMENTO":
        return this.getFormattersSenhaAtendimento();

      case "DOCUMENTACAO":
        return this.getFormattersDocumentacao();

      case "SASE_CE":
        return this.getFormattersSaseCe();

      case "SASE_CE_DECLARADOS":
        return this.getFormattersSaseCeDeclarados();

      case "DASHBOARD":
        return this.getFormattersDashboard();

      case "EVENTO":
      case "TIPO_RESULTADO":
      case "TIPO_INCONFORMIDADE":
      case "TIPO_BEM_MOVEL":
      case "FRASES_LIVRO":
      case "RECIBO_ETIQUETA":
      case "VISUALIZACAO_TELA":
      case "SITE_COMENTARIO":
      case "EXECUCAO_ARISP_PROTOCOLO_RI":
      case "EXECUCAO_ARISP_CERTIDAO_RI":
      case "PAUSA":
      case "INDICADOR_REAL_UNIDADE":
      case "DARF":
      case "ONRTDPJ":
      case "ONRTDPJ_PROTOCOLAR_RTD":
      case "ONRTDPJ_PROTOCOLAR_RCPJ":
      case "ONRTDPJ_ENTREGA_ELETRONICA_RTD":
      case "ONRTDPJ_ENTREGA_ELETRONICA_RCPJ":
      default:
        return this.getFormattersDefault();
    }
  },

  // ==============
  // Funções por entidade
  // ==============

  getFormattersDefault() {
    return this.default;
  },

  getFormattersAtribuicao() {
    return [
      { label: "Usuário", key: "usuario", type: "json" },
      {
        label: "Usuários",
        key: "usuarios",
        formatter: (registros) => {
          return registros?.length
            ? `<div class="html-field"><ul>${registros.map(text => `<li>${text?.login}</li>`).join('') || '-'}</ul></div>`
            : "-";
        }
      },
      { label: "Etapa", key: "etapa", type: "json" },
      {
        label: "Etapas",
        key: "etapas",
        formatter: (registros) => {
          return registros?.length
            ? `<div class="html-field"><ul>${registros.map(text => `<li>${text?.nome}</li>`).join('') || '-'}</ul></div>`
            : "-";
        }
      },
      { label: "Tipo de Serviço", key: "tipoServico", type: "json" },
      {
        label: "Tipos de Serviços",
        key: "tipoServicos",
        formatter: (registros) => {
          return registros?.length
            ? `<div class="html-field"><ul>${registros.map(text => `<li>${text?.nome}</li>`).join('') || '-'}</ul></div>`
            : "-";
        }
      }
    ];
  },

  getFormattersDashboard() {
    return [
      { label: "Nome", key: "nome" },
      {
        label: "Compartilhamento",
        key: "usuarios",
        formatter: (registros) => {
          return registros?.length
            ? `<div class="html-field"><ul>${registros.map(registro => `<li>${registro?.usuario?.nome}${registro?.edicao === true ? ' (pode editar)' : ''}</li>`).join('') || '-'}</ul></div>`
            : "-";
        }
      },
      {
        label: "Conteúdo",
        key: "abas",
        formatter: (abas) => {
          return abas?.length
            ? `<div class="html-field"><ul>${abas.map(aba => `<li>${aba?.nome}${aba?.itens?.length ? `<ul>${aba.itens.map(item => `<li>${item?.widget?.view?.title}</li>`).join('')}</ul>` : ''}</li>`).join('') || '-'}</ul></div>`
            : "-";
        }
      }
    ];
  },

  getFormattersDepartamento() {
    return this.default;
  },

  getFormattersGrupoPermissao() {
    return [
      ...this.default,
      {
        label: "Usuários",
        key: "usuarios",
        formatter: (value) => value?.length ? `${value.map(text => `${text.nome}<br />`).join('') || '-'}` : "-"
      },
      { label: "Permissões", key: "permissao", type: "grupo-permissao" }
    ];
  },

  getFormattersUsuario() {
    return [
      ...this.default,
      { label: "IP", key: "ip" },
      { label: "E-mail", key: "email" },
      { label: "Departamento", key: "departamento", type: "json" },
      { label: "Cargo", key: "cargo" },
      { label: "Matrícula Funcional", key: "matriculaFuncional" },
      { label: "NIT/PIS", key: "nitPis" },
      { label: "Data de Admissão", key: "dataAdmissao", type: "date" },
      { label: "Designação", key: "designacao" },
      { label: "CPF", key: "cpf" },
      { label: "Login", key: "login" },
      { label: 'Matrícula TJRJ', key: 'matricula' },
      { label: "Auditor", key: "auditor", type: "boolean" },
      { label: "Permitir acesso com Certificado Digital?", key: "permitirAcessoCertificadoDigital", type: "boolean" },
      { label: "Assinatura", key: "assinatura", type: "image-from-anexo" },

      { label: "Administrador", key: "administrador", type: "boolean", group: "Permissões" },
      { label: "Financeiro", key: "financeiro", type: "boolean", group: "Permissões" },
      { label: "Gestor", key: "gestor", type: "boolean", group: "Permissões" },
      { label: "Digitalizador", key: "digitalizador", type: "boolean", group: "Permissões" },
      { label: "Atendente", key: "atendente", type: "boolean", group: "Permissões" },

      { label: "Guichê", key: "guiche", group: "Atendimento" },
      {
        label: "Caixa",
        key: "caixa",
        group: "Atendimento",
        formatter: async (value) => value?.nome ? value?.nome : await AuditoriaBusiness.nomearCaixa(value)
      },
      { label: "Valor Sangria", key: "sangria", type: "currency", group: "Atendimento" },
      { label: "Valor Caixa", key: "valorCaixa", type: "currency", group: "Atendimento" },
      {
        label: "Filas de Atendimento",
        key: "filasAtendimento",
        group: "Atendimento",
        formatter: async (value) => await AuditoriaBusiness.filaAtendimento(value)
      },

      { label: "DOI", key: "doi", type: "boolean", group: "Relatórios & Paineis" },
      { label: "CPAI", key: "cpai", type: "boolean", group: "Relatórios & Paineis" },
      { label: "Livro Diário Auxiliar de Receitas e Despesas", key: "livroReceitaDespesa", type: "boolean", group: "Relatórios & Paineis" },
      { label: "Livro Controle de Depósito Prévio", key: "livroDepositoPrevio", type: "boolean", group: "Relatórios & Paineis" },
      { label: "Livro Protocolo", key: "livroProtocolo", type: "boolean", group: "Relatórios & Paineis" },
      { label: "Relatório Sintético", key: "configuracaoAcesso.relatorioSintetico", type: "boolean", group: "Relatórios & Paineis" },
      { label: "Relatório de Selos Enviados", key: "configuracaoAcesso.relatorioSelosEnviados", type: "boolean", group: "Relatórios & Paineis" },

      { label: "Visualizar Painel de Atendimento", key: "painelAtendimento", type: "boolean", group: "Relatórios & Paineis" },

      { label: "Receber Alertas do E-certidão", key: "alertaCertidao", type: "boolean", group: "Alertas" },
      { label: "Receber Alertas de Redimensionamento dos Selos", key: "alertaRedimensionamentoSelo", type: "boolean", group: "Alertas" },

      { label: "Horário de entrada", key: "horarioEntrada", group: "Período de atividade" },
      { label: "Horário de saída", key: "horarioSaida", group: "Período de atividade" },
      { label: "Horário de intervalo total", key: "horarioIntervalo", group: "Período de atividade" },

      {
        label: "Período de bloqueio de acesso",
        key: "listaBloqueio",
        formatter: async (value) => await AuditoriaBusiness.listaBloqueio(value)
      },
      { label: "Última atualização de senha", key: "atualizacaoSenha", type: "datetime" },
      {
        label: "Grupos de Permissões",
        key: "gruposPermissoes",
        formatter: (value) => value?.length ? `${value.map(text => `${text.nome}<br />`).join('') || '-'}` : "-"
      }
    ];
  },

  getFormattersLista() {
    return [
      ...this.default,
      { label: "Lista", key: "lista", type: "listahtml" }
    ];
  },

  async getFormattersChecklist() {
    return [
      ...this.default,
      { label: "Titulo", key: "titulo" },
      { label: "Protocolo", key: "protocolo", type: "boolean" },
      { label: "Tipo Checklist", key: "tipoChecklist", type: "enum", lista: await ChecklistBusiness.getLstTipoChecklist() },
      // '-' no lugar de "Não" de propósito: a linha só aparece quando alguém ligou ou desligou a
      // integração, porque com os dois lados em '-' a auditoria omite a linha. Assim o cartório que
      // nunca usou o Odin não passa a ver uma opção que a tela não lhe mostra.
      { label: "Integrar ao Odin", key: "integrarOdin", formatter: (value) => value ? 'Sim' : '-' },
      { label: "Tags", key: "tags", type: "listaHtml" },
      { label: "Checklist", key: "checklist", formatter: async (value) => await AuditoriaBusiness.checklist(value) },
      { label: "Vínculos", key: "vinculos" }
    ];
  },

  getFormattersFragmento() {
    return [
      ...this.default,
      { label: "Índice", key: "indice" },
      { label: "Tags", key: "tags", type: "listaHtml" },
      { label: "Observação", key: "observacao" },
      { label: "Minuta", key: "minuta", type: "ide-minuta" }
    ];
  },

  getFormattersModeloTextual() {
    return [
      ...this.default,
      { label: "Minuta", key: "minuta", type: "ide-minuta" }
    ];
  },

  getFormattersLayoutImpressao() {
    return [
      ...this.default,
      { label: "Tipo", key: "tipo", type: "enum", lista: LayoutImpressaoBusiness.getTipos() },
      { label: "Motor de geração do PDF", key: "motorGeracaoPdf", type: "enum", lista: VueBusiness.getVueRoot().enums?.EnumMotorGeracaoPdf || [] },
      { label: "Qualidade das imagens", key: "dpiDigitalizacao", type: "enum", lista: VueBusiness.getVueRoot().enums?.EnumDpiDigitalizacao },
      { label: "Certidão de Notificação", key: "certidaoNotificacao", type: "boolean" },
      {
        label: "CNM",
        key: "configuracao",
        formatter: (a, b) => {
          if (!a || b.tipo != "CNM") {
            return "";
          }
          return `
                    <p><strong>Fonte da Letra</strong>: ${a.cnmFont}</p>
                    <p><strong>Tamanho da Letra</strong>: ${a.cnmTamanho}</p>
                    <p><strong>Margem Topo (mm)</strong>: ${a.cnmY}</p>
                    <p><strong>Margem Direita (mm)</strong>: ${a.cnmX}</p>
                    <p><strong>Incluir fundo</strong>: ${a.cnmFundo ? "Sim" : "Não"}</p>
                    <p><strong>Redefinir largura da digitalização</strong>: ${a.cnmLargura || "-"}</p>
                    <p><strong>Adicionar quadro</strong>: ${a.cnmQuadro ? "Sim" : "Não"}</p>
                  `;
        }
      },
      { label: "Configuração", key: "configuracao", type: "configuracao-impressao" },
      { label: "Dominio Protocolo", key: "dominioProtocolo", type: "listaEnum", lista: ProtocoloBusiness.getTiposProtocolo() },
      { label: "Dominio Certidão", key: "dominioCertidao", type: "listaEnum", lista: ProtocoloBusiness.getTiposCertidao() },
      { label: "Template", key: "template", type: "ide-minuta" }
    ];
  },

  getFormattersTipoDocumento() {
    return [
      ...this.default,
      { label: "Atribuições", key: "atribuicao", type: "array" },
      { label: "Checklists", key: "checklists", formatter: async (value) => await AuditoriaBusiness.checklists(value) }
    ];
  },

  getFormattersRepasse() {
    return [
      ...this.default,
      { label: "Valor", key: "valor", type: "currency" },
      { label: "Grupo", key: "grupo" },
      { label: "Data Vigência (Início)", key: "inicioVigencia", type: "date" },
      { label: "Data Vigência (Fim)", key: "fimVigencia", type: "date" },
      {
        label: "Categoria",
        key: "categoria",
        formatter: async (value) => value?.nome ? value?.nome : await AuditoriaBusiness.nomearCategoria(value)
      }
    ];
  },

  /**
   * Crédito extra de processamento do Odin.
   *
   * Sem `...this.default`: o snapshot auditado tem só o par quanto/até quando — nada de `nome`,
   * `ativo` ou `dominio`. Quem lançou é o usuário da própria auditoria, e o motivo está na descrição;
   * nenhum dos dois é campo do snapshot. A data já chega formatada do backend, por isso sem `type`.
   */
  getFormattersCreditoExtraOdin() {
    return [
      { label: "Créditos por mês", key: "creditos", type: "integer" },
      { label: "Válido até", key: "validoAte" }
    ];
  },

  getFormattersFeriado() {
    return [
      ...this.default,
      { label: "Dia", key: "dia", type: "date" },
      { label: "Recorrente", key: "recorrente", type: "boolean" }
    ];
  },

  async getFormattersTag() {
    return [
      ...this.default,
      { label: "Cor", key: "cor" },
      { label: "Tipos de Vínculo", key: "tipoVinculo", type: "listaEnum", lista: await TagBusiness.getTiposVinculo() }
    ];
  },

  async getFormattersPapel() {
    return [
      ...this.default,
      { label: "Classes", key: "classes", type: "listaEnum", lista: await PapelBusiness.getClasses() },
      { label: "Domínios", key: "dominios", type: "listaEnum", lista: DominioBusiness.getDominios() }
    ];
  },

  getFormattersCaixa() {
    return [
      ...this.default,
      {
        label: "Tipo",
        key: "tipo",
        type: "enum",
        lista: [
          { id: "BANCO", nome: "Banco" },
          { id: "CONTROLE", nome: "Controle" },
          { id: "INTERNO", nome: "Interno" },
          { id: "GUICHE", nome: "Guichê" }
        ]
      },
      { label: "Permitir Depósito Prévio", key: "protocolo", type: "boolean" },
      { label: "Data", key: "diaInicio", type: "date" },
      { label: "Saldo Inicial", key: "saldoInicial", type: "currency" }
    ];
  },

  getFormattersCategoria() {
    return [
      ...this.default,
      { label: "Tipo", key: "tipo" },
      { label: "Dedutível do IR?", key: "dedutivelImposto", type: "boolean" },
      { label: "Apresentar no Livro de Receita e Despesa?", key: "livroReceitaDespesa", type: "boolean" },
      { label: "Apresentar no Livro Caixa (Carnê Leão)?", key: "livroCarneLeao", type: "boolean" },
      {
        label: "Categoria Pai",
        key: "categoriaId",
        formatter: async (value) => value?.nome ? value?.nome : await AuditoriaBusiness.nomearCategoria(value)
      },
      { label: "Código Conta Contábil", key: "codContabil" }
    ];
  },

  getFormattersFilaAtendimento() {
    return [
      ...this.default,
      { label: "Sigla", key: "sigla" },
      { label: "Ordem", key: "ordem" },
      { label: "Prioridade de Chamada", key: "prioridade" },
      { label: "Primeira Senha", key: "primeiraSenha" },
      { label: "Sequencia Individual", key: "sequenciaIndividual", type: "boolean" },
      { label: "Senha Comum", key: "comum", type: "boolean" },
      { label: "Senha Prioritária", key: "prioritaria", type: "boolean" },
      { label: "Senha interna", key: "interna", type: "boolean" }
    ];
  },

  getFormattersAnexoSistema() {
    return [
      ...this.default,
      { label: "Tags", key: "tags", type: "listaHtml" }
    ];
  },

  getFormattersConfiguracao() {
    let listasPromise = null;
    const getListas = () => {
      if (listasPromise === null) {
        listasPromise = (async () => {
          let listas = {};
          listas.acompanhamentoOnline = ConfiguracaoBusiness.getAcompanhamentoOnline();
          let promisses = [];
          promisses.push(NaturezaBusiness.getAllSimpleList().then(e => listas.naturezas = e));
          promisses.push(TipoServicoBusiness.getByDominioSimplesTodos("PROTOCOLO_RI").then(e => listas.tipoServico = e));
          promisses.push(TipoServicoBusiness.getByDominioSimplesTodos("CERTIDAO_RI").then(e => listas.tipoServicoCertidao = e));
          promisses.push(TipoServicoBusiness.getByDominioSimplesTodos("PROTOCOLO_RTD").then(e => listas.tipoServicoRtd = e));
          promisses.push(EtapaBusiness.getAllSimpleList().then(e => listas.etapas = e));
          promisses.push(CaixaBusiness.getAllSimpleList().then(e => listas.caixas = e));
          promisses.push(UsuarioBusiness.getAllSimpleList().then(e => listas.usuarios = e));
          promisses.push(LayoutImpressaoBusiness.listByTipo("EXTRATO").then(e => listas.extrato = e));
          promisses.push(LayoutImpressaoBusiness.listByTipo("REGISTRO_TD").then(e => listas.layoutsRtd = e));
          promisses.push(LayoutImpressaoBusiness.listByTipo("REGISTRO_PJ").then(e => listas.layoutsRcpj = e));
          promisses.push(TipoDocumentoBusiness.getAllSimpleList().then(e => listas.documentos = e));
          promisses.push(CategoriaBusiness.getAllSimpleList().then(e => listas.categorias = e));
          promisses.push(ListaBusiness.getAllSimpleList().then(e => listas.listas = e));
          promisses.push(FragmentoBusiness.getAllSimpleList().then(e => listas.fragmentos = e));
          promisses.push(ConfiguracaoBusiness.getLstTipoSelecaoIndicadorPessoal().then(e => listas.tipoSelecaoIndicadorPessoal = e));
          promisses.push(ListaBusiness.getAllSimpleList().then(l => listas.listas = l));
          promisses.push(TagBusiness.getByTipo('ANEXO').then(e => listas.tagsAnexo = e));
          promisses.push(ConfiguracaoBusiness.getEnums().then(e => listas.tipoAtoOnrtdpj = e.EnumTipoAtoOnrtdpj || []));
          await Promise.all(promisses);
          return listas;
        })();
      }
      return listasPromise;
    };

    const f = (tipo) => async (value) => {
      if (value == null) return null;
      return await AuditoriaBusiness.cartorio(value, tipo, await getListas());
    };

    return [
      ...this.default,
      { label: "Estado", key: "estado", type: "enum", lista: EnderecoBusiness.getEstados() },
      { label: "Cidade", key: "cidade" },
      { label: "Cartório", key: "detalhesCartorio", type: "string", formatter: f("detalhesCartorio") },
      { label: "E-mail", key: "email", type: "string", formatter: f("email") },
      { label: "Whatsapp", key: "whatsapp", type: "string", formatter: f("whatsapp") },
      { label: "Selo", key: "selo", type: "string", formatter: f("selo") },
      { label: "Indisponibilidade", key: "indisponibilidade", type: "string", formatter: f("indisponibilidade") },
      { label: "Nota Fiscal", key: "notaFiscal", type: "string", formatter: f("notaFiscal") },
      { label: "Exigência", key: "exigencia", type: "string", formatter: f("exigencia") },
      { label: "Aguardando Pagamento", key: "aguardandoPagamento", type: "string", formatter: f("aguardandoPagamento") },
      { label: "Cabeçalho do Site de Acompanhamento", key: "cabecalhoSite", type: "ide-minuta" },
      { label: "Site", key: "site", type: "string", formatter: f("site") },
      { label: "See", key: "see", type: "string", formatter: f("see") },
      { label: "Sinter", key: "sinter", type: "string", formatter: f("sinter") },
      { label: "CORI-SC", key: "corisc", type: "string", formatter: f("corisc") },
      { label: "Central Estadual", key: "centralEstadual", type: "string", formatter: f("centralEstadual") },
      { label: "ONR", key: "arisp", type: "string", formatter: f("arisp") },
      { label: "ONRTDPJ", key: "onrtdpj", type: "string", formatter: f("onrtdpj") },
      { label: "Atendimento", key: "atendimento", type: "string", formatter: f("atendimento") },
      { label: "Parcela Express", key: "parcelaExpress", type: "string", formatter: f("parcelaExpress") },
      { label: "Configuração Cartão de Débito", key: "debito", type: "string", formatter: f("debito") },
      { label: "Configuração Cartão de Crédito", key: "credito", type: "string", formatter: f("credito") },
      { label: "Configuração Depósito em Conta", key: "deposito", type: "string", formatter: f("deposito") },
      { label: "Configuração PIX", key: "pix", type: "string", formatter: f("pix") },
      { label: "Configuração Dinheiro", key: "dinheiro", type: "string", formatter: f("dinheiro") },
      { label: "Configuração Cheque", key: "cheque", type: "string", formatter: f("cheque") },
      { label: "Financeiro", key: "financeiro", type: "string", formatter: f("financeiro") },
      { label: "Templates", key: "outrosTemplates", type: "string", formatter: f("outrosTemplates") },
      { label: "Peer", key: "peerBanco", type: "string", formatter: f("peerBanco") },
      { label: "Livros", key: "livros", type: "string", formatter: f("livros") },
      { label: "Tabelionato de Notas", key: "tabelionatoGeral", type: "string", formatter: f("tabelionatoGeral") },
      { label: "Serviços", key: "tabelionatoServicos", type: "string", formatter: f("tabelionatoServicos") },
      { label: "Gestão", key: "tabelionatoGestao", type: "string", formatter: f("tabelionatoGestao") },
      { label: "Livros", key: "livrosTabelionato", type: "string", formatter: f("livrosTabelionato") },
      { label: "Arquivo Morto", key: "detalhesCartorio", type: "string", formatter: f("arquivoMorto") },
      { label: "Geral", key: "geral", type: "string", formatter: f("geral") },
      { label: "Calculadora de Valor Venal", key: "calculadoraValorVenal", type: "string", formatter: f("calculadoraValorVenal") },
      { label: "Serventias do Registro Anterior", key: "listaRegistroAnterior", type: "string", formatter: f("listaRegistroAnterior") },
      { label: "Finalidade Certidão", key: "listaFinalidade", type: "string", formatter: f("listaFinalidade") },
      { label: "Resumo - Indicador Real", key: "resumoIndicadorReal", type: "string", formatter: f("resumoIndicadorReal") },
      { label: "Linha de Segurança", key: "pdf", type: "string", formatter: f("pdf") },
      { label: "Margem aceitável de diferença de fração na transferência de imóveis", key: "configuracaoFracaoTransferenciaImovel", type: "string", formatter: f("configuracaoFracaoTransferenciaImovel") },
      { label: "Indicador Real", key: "indicadorReal", type: "string", formatter: f("indicadorReal") },
      { label: "Odin - Inteligência Artificial", key: "odin", type: "string", formatter: f("odin") }
    ];
  },

  getFormattersAgendamentosTarefas() {
    return [
      ...this.default,
      { label: "Natureza", key: "natureza" },
      { label: "Tipo de Tarefa", key: "tipoServico" },
      { label: "Etapa", key: "etapa" },
      { label: "Título", key: "titulo" },
      { label: "Descrição", key: "descricao" },
      { label: "Periodicidade", key: "periodicidade" },
      { label: "Próxima Geração", key: "proximaGeracao", type: "date" },
      { label: "Interessado", key: "interessado", formatter: (value) => value?.nome },
      { label: "Solicitante", key: "solicitante", formatter: (value) => value?.nome },
      { label: "Usuários", key: "usuarios", formatter: (value) => value?.length ? `${value.map(text => `${text.nome}<br />`).join('') || '-'}` : "-" },
      { label: "Todos os usuários", key: "todosUsuarios", type: "boolean" }
    ];
  },

  getFormattersFolhaPagamento(auditoria) {
    return [
      { label: "Nome", key: "nome" },
      { label: "CPF", key: "cpf" },
      { label: "Matrícula", key: "matricula" },
      { label: "NIT/PIS", key: "nitPis" },
      { label: "Data de Admissão", key: "admissao", type: "date" },
      { label: "Cargo", key: "cargo" },
      { label: "Designação", key: "designacao" },
      { label: "Salário Bruto", key: "salarioBruto", type: "currency" },
      { label: "Salário Líquido", key: "salarioLiquido", type: "currency" },
      { label: "Décimo Terceiro", key: "decimoTerceiro", type: "currency" },
      { label: "Parcela do Décimo", key: "parcelaDecimo" },
      { label: "Férias", key: "ferias", type: "currency" },
      { label: "FGTS", key: "fgts", type: "currency" },
      { label: "INSS", key: "inss", type: "currency" },
      { label: "IRRF", key: "irrf", type: "currency" },
      { label: "Observação", key: "observacao" },
      { label: "Competência", key: "competencia", type: "date" },
    ];
  },

  getFormattersFolhaSeguranca() {
    return [
      { label: "Folha", key: "folha", type: "integer"},
      { label: "Lote", key: "serie", type: "string"},
      { label: "Domínio", key: "dominio", type: "string", formatter: (value) => AuditoriaBusiness.getLabelDominioFolhaSeguranca(value)},
      { label: "Status", key: "status", type: "string"},
      { label: "Folha Inicial", key: "folhaInicial", type: "integer"},
      { label: "Folha Final", key: "folhaFinal", type: "integer"},
      { label: "Responsável recebimento", key: "responsavelRecebimento", formatter: (value) => AuditoriaBusiness.getEntityById(value, UsuarioBusiness)},
      { label: "Recebimento", key: "recebimento", type: "date"},
      { label: "Registro Ativo", key: "ativo", type: "boolean" },
      { label: "Identificador", key: "id" },
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Atualização", key: "atualizacao", type: "datetime" },
    ];
  },

  async getFormattersTipoServico(dominio) {
    let formatters = [...this.default,
      { label: "Minuta", key: "minuta", type: "ide-minuta" }
    ];

    if (!["OFICIO", "NOTIFICACAO", "OCORRENCIA"].includes(dominio)) {
      formatters = [
        ...formatters,
        { label: "Pode isentar?", key: "isento", type: "boolean" },
        { label: "Regra custas", key: "regraCustas" }
      ];
    }

    if (!["OCORRENCIA"].includes(dominio)) {
      formatters = [
        ...formatters,
        { label: "Opções", key: "opcoes", formatter: async (value) => await AuditoriaBusiness.opcoes(value, dominio) }
      ];
    }

    if (["PROTOCOLO_RTD"].includes(dominio)) {
      formatters = [
        ...formatters,
        { label: "Tipo Ato Sinter", key: "tipoAtoSinter", type: "string" },
        { label: "Subtipo Ato Sinter", key: "subtipoAtoSinter", type: "string" }
      ];
    }

    formatters = [
      ...formatters,
      { label: "Tipo de Registro/Averbação [Tribunal]", key: "tipoTribunal", type: "enum", list: await TipoServicoBusiness.getTiposAtoTribunal(dominio) },
      { label: "Tipo Ato [Tribunal/Cobrança]", key: "tipoCobranca", type: "enum", list: await TipoServicoBusiness.getTiposCobrancaTribunal(dominio) },
      { label: "Checklists", key: "checklists", formatter: async (value) => await AuditoriaBusiness.checklists(value) },
      { label: "Tipos de Serviços Relacionados", key: 'vinculosProtocolo', formatter: async (value) => await AuditoriaBusiness.tipoServicos(value) },
      { label: "Tipos de Certidões Relacionadas", key: 'vinculosCertidao', formatter: async (value) => await AuditoriaBusiness.tipoServicos(value) },
    ];

    return formatters;
  },

  async getFormattersEtapa(dominio) {
    let formatters = [
      ...this.default,
      { label: "Cor", key: "cor" },
      { label: "Ordem", key: "ordem" },
      {
        label: "Tipo",
        key: "tipo",
        type: "enum",
        lista: [
          { id: "QUALIFICACAO", nome: "Qualificação" },
          { id: "REGISTRO", nome: "Registro" },
          { id: "POS_REGISTRO", nome: "Pós-Registro" },
          { id: "INTERNA", nome: "Interna" },
          { id: "EXTERNA", nome: "Externa" },
          { id: "EXIGENCIA", nome: "Exigência" },
          { id: "AGUARDANDO_PAGAMENTO", nome: "Aguardando Pagamento" }
        ]
      },
      { label: "Nome (Site)", key: "site" },
      { label: "Pode cancelar?", key: "podeCancelar", type: "boolean" },
      { label: "Pode finalizar?", key: "podeFinalizar", type: "boolean" },
      { label: "Encaminhar para a etapa (finalização)", key: "encaminharEtapa", type: "json" },
      { label: "Encaminhar para a etapa (cancelamento)", key: "encaminharEtapaCancelamento", type: "json" },
      { label: "Pode voltar?", key: "podeVoltar", type: "boolean" }
    ];

    if (!DominioBusiness.isDominioAuxiliar(dominio)) {
      formatters = [
        ...formatters,
        { label: "Gerar Exigência?", key: "gerarNotaExigencia", type: "boolean" },
        { label: "Assinar nota de exigência automaticamente?", key: "assinarAutomaticamente", type: "boolean" },
        { label: "Marcar documento entregue ao entrar na etapa?", key: "marcarEntrega", type: "boolean" }
      ];
    }

    formatters = [
      ...formatters,
      { label: "Enviar E-mail [Exigência/Aguardando Pagamento/Finalização]?", key: "enviarEmail", type: "boolean" },
      ...(dominio !== 'CERTIDAO_TN' ? [{ label: DominioBusiness.getDominiosLivroUnico().includes(dominio) ? "Pode lavrar?" : "Pode registrar?", key: "podeRegistrar", type: "boolean" }] : []),
      { label: "Permitir apenas protocolos vigentes?", key: "apenasVigentes", type: "boolean" }
    ];

    if (DominioBusiness.isProtocolo(dominio)) {
      formatters = [
        ...formatters,
        { label: "Permitir apenas protocolos selados?", key: "isento", type: "apenasSelados" },
        { label: "Permitir apenas prenotações seladas?", key: "isento", type: "apenasPrenotocaoSelada" }
      ];
    }

    formatters = [
      ...formatters,
      { label: "Alertar ao entrar nesta etapa com o saldo negativo?", key: "alertaSaldoNegativo", type: "boolean" },
      { label: "Alertar ao entrar na etapa quando não houver link de pagamento?", key: "alertaLinkPagamento", type: "boolean" },
      { label: "Atribuir automaticamente?", key: "atribuirAutomaticamente", type: "boolean" }
    ];

    if (!DominioBusiness.isDominioAuxiliar(dominio)) {
      formatters = [
        ...formatters,
        { label: "Distribuir protocolo nesta etapa?", key: "distribuirProtocolo", type: "boolean" },
        { label: "Permitir entrar nesta etapa com saldo negativo?", key: "permitirSaldoNegativo", type: "boolean" },
        { label: "Permitir entrar nesta etapa com saldo pendente?", key: "permitirSaldoPendente", type: "boolean" }
      ];
    }

    if (['OFICIO', 'OCORRENCIA', 'NOTIFICACAO'].includes(dominio)) {
      formatters = [
        ...formatters,
        { label: "Distribuir protocolo nesta etapa?", key: "distribuirProtocolo", type: "boolean" }
      ];
    }

    formatters = [
      ...formatters,
      { label: "Fluxo de etapas permitidas", key: "proxima", type: "listaEnum", lista: await EtapaBusiness.getSimpleList() },
      { label: "Tipos permitidos", key: "tiposProtocolo", type: "listaEnum", lista: ProtocoloBusiness.getTiposProtocolo() },
      { label: "Permitir realizar o processamento automático?", key: "permitirProcessamentoAutomatico", type: "boolean" },
      { label: "Finalizar o pedido automaticamente nessa etapa?", key: "finalizarAutomaticamente", type: "boolean" },
      { label: "Alerta", key: "tempoParado", formatter: async (value) => await AuditoriaBusiness.tempoParado(value) },
      { label: "Checklists", key: "checklists", formatter: async (value) => await AuditoriaBusiness.checklists(value) }
    ];

    return formatters;
  },

  getFormattersTarefa() {
    return [
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Título", key: "titulo", type: "string" },
      { label: "Tipo de Tarefa", key: "tipoServico", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoServicoBusiness) },
      { label: "Descrição", key: "descricao", type: "string" },
      { label: "Solicitante", key: "solicitante", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },
      { label: "Interessado", key: "interessado", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getUsuario(value) },
      { label: "Adiamento", key: "adiamento", type: "datetime" }
    ];
  },

  getFormattersAtividadeChecklist() {
    return [
      { label: "Índices", key: "indices", type: "checklist", group: "Checklist" }
    ];
  },

  getFormattersDigitalizacao() {
    return [
      { label: "Ordem", key: "ordem", type: "string" },
      { label: "Nome", key: "nomeAnexo", type: "string" },
      { label: "Caminho", key: "caminho", type: "string" },
      { label: "Paginas", key: "totalPagina", type: "string" },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getEntityById(value, UsuarioBusiness) }
    ];
  },

  getFormattersIndicadorReal() {
    return IndicadorRealBusiness.getFormatters();
  },

  getFormattersIndicadorRealExterno() {
    return [
      {label: 'Serventia', key: 'serventia', type: 'string'},
      {label: 'Tipo', key: 'tipo', type: 'string'},
      {label: 'Código', key: 'codigo', type: 'string'},
      {label: 'Letra', key: 'livroLetra', type: 'string'},
      {label: 'Livro (Número)', key: 'livroNumero', type: 'string'},
      {label: 'Folha', key: 'livroFolha', type: 'string'},
      {label: 'CNM', key: 'cnm', type: 'string'},
      {label: 'CNS', key: 'cns', type: 'string'},
      {label: 'Data Encerramento', key: 'encerramento', type: 'date'},
      {label: 'Especificação', key: 'especificacao', type: 'string'},
      {label: 'Categoria', key: 'categoria', type: 'string'},
      {label: 'Tipo de Imóvel', key: 'tipoImovel', type: 'string'},
      {label: 'Imóvel da União', key: 'imovelUniao', type: 'boolean'},
      {label: 'CEP', key: 'cep', type: 'string'},
      {label: 'Cidade', key: 'cidade', type: 'string'},
      {label: 'Estado', key: 'estado', type: 'string'},
      {label: 'Bairro', key: 'bairro', type: 'string'},
      {label: 'Tipo Logradouro', key: 'tipoLogradouro', type: 'string'},
      {label: 'Logradouro', key: 'logradouro', type: 'string'},
      {label: 'Número', key: 'numero', type: 'string'},
      {label: 'Complemento', key: 'complemento', type: 'string'},
      {label: 'Cadastro Imobiliário', key: 'cadastroImobiliario', type: 'string'},
      {label: 'Código SNCR', key: 'codigoSncr', type: 'string'},
      {label: 'INCRA', key: 'incra', type: 'string'},
      {label: 'Localização', key: 'localizacao', type: 'string'},
      {label: 'Denominação', key: 'denominacao', type: 'string'},
      {label: 'Código IBGE', key: 'cidadeIbge', type: 'string'},
      {label: 'Medida Área', key: 'medidaArea', type: 'enum', lista: IndicadorRealBusiness.getMedidas(), group: 'Área'},
    ];
  },

  getFormattersIndicadorPessoal(auditoria) {
    let formatters = [
      { label: "Versão", key: "versao" },
      { label: "Nome", key: "nome" },
      { label: "Nome Social", key: "nomeSocial" },
      { label: "Tipo de pessoa", key: "tipoPessoa", type: "enum", lista: IndicadorPessoalBusiness.getTiposPessoa() },
      { label: "CPF/CNPJ desconhecido?", key: "documentoDesconhecido", type: "boolean" },
      { label: "Motivo do CPF/CNPJ desconhecido", key: "motivoDocumentoDesconhecido", type: "enum", lista: [{ id: "DECISAO_JUDICIAL", nome: "Sem CPF/CNPJ - Decisão Judicial" }, { id: "NAO_CONSTA", nome: "Não consta no documento" }] },
      { label: "CPF/CNPJ", key: "documento" }
    ];

    if (auditoria.tipoPessoaAntes === "FISICA" || auditoria.tipoPessoaDepois === "FISICA") {
      formatters.push(
        { label: "RG", key: "rg" },
        { label: "Orgão Emissor", key: "orgaoEmissor" },
        { label: "CNH", key: "cnh" },
        { label: "Identidade profissional", key: "cip" },
        { label: "Passaporte", key: "passaporte" },
        { label: "Outros Documentos", key: "outrosDocumentos" },
        { label: "Registro Nacional Migratório (antigo)", key: "registroNacionalMigratorio" },
        { label: "RNM (Registro Nacional Migratório)", key: "rnm" },
        { label: "Validade RNM", key: "dataRnm", type: "date" },
        { label: "Órgão Emissor RNM", key: "emissorRnm" },
        {label: 'Possui filhos brasileiros?', key: 'possuiFilhosBrasileiros', type: 'string', formatter: (value) => {
            const opcoes = {SIM: 'Sim', NAO: 'Não', NAO_INFORMADO: 'Não Informado'};
            return opcoes[value] || value;
        }},
        { label: "Pessoa falecida?", key: "falecido", type: "boolean" },
        { label: "Data do Óbito", key: "dataObito", type: "date" },
        { label: "Certidão de Óbito", key: "certidaoObito", type: "string" },
        { label: "Menor de idade?", key: "menor", type: "boolean" },
        { label: "Incapaz?", key: "incapaz", type: "boolean" },
        { label: "Pessoa exposta politicamente?", key: "expostaPoliticamente", type: "boolean" },
        { label: "Servidor Público?", key: "servidorPublico", type: "boolean" },
        { label: "Deficiente Visual ou Visão Subnormal?", key: "deficienteVisual", type: "boolean" },
        { label: "Semialfabetizado?", key: "semialfabetizado", type: "boolean" }
      );
    } else {
      formatters.push(
        { label: "Nome Fantasia (Denominação)", key: "denominacao" },
        { label: "Sexo/Gênero no Texto", key: "sexo", type: "enum", lista: IndicadorPessoalBusiness.getSexos() }
      );
    }

    formatters.push(
      { label: "Optante de Substituição Tributária?", key: "substituicaoTributaria", type: "boolean" },
      { label: "Pessoa Obrigada?", key: "pessoaObrigada", type: "boolean" },
      { label: "Permitir uso como fornecedor?", key: "fornecedor", type: "boolean" },
      { label: "Sequencial", key: "sequencial" }
    );

    if (auditoria.tipoPessoaAntes === "FISICA" || auditoria.tipoPessoaDepois === "FISICA") {
      formatters.push(
        { label: "Sexo/Gênero no Texto", key: "sexo", type: "enum", lista: IndicadorPessoalBusiness.getSexos(), group: "Dados Básicos" },
        { label: "Data de nascimento", key: "nascimento", type: "date", group: "Dados Básicos" },
        { label: "Nacionalidade", key: "nacionalidade", type: "enum", lista: IndicadorPessoalBusiness.getNacionalidades(), group: "Dados Básicos" },
        { label: "Profissão", key: "profissao", group: "Dados Básicos" },
        { label: "Nome do pai", key: "nomePai", group: "Dados Básicos" },
        { label: "Nome da mãe", key: "nomeMae", group: "Dados Básicos" },
        { label: "Estado civil", key: "estadoCivil", type: "enum", lista: IndicadorPessoalBusiness.getEstadosCivil(), group: "Dados Básicos" },
        { label: "Tipo Separação", key: "tipoSeparacao", type: "enum", lista: IndicadorPessoalBusiness.getTipoSeparacao(), group: "Dados Básicos" },
        { label: "Indicador da União?", key: "indicadorUniao", type: "boolean", group: "Dados Básicos" },
        { label: "União estável?", key: "possuiUniaoEstavel", type: "boolean", group: "Dados Básicos", alt: "Não Informado" },
        { label: "Cônjuge", key: "conjugeId", formatter: async (value) => AuditoriaBusiness.getEntityById(value, IndicadorPessoalBusiness), group: "Dados do casamento/união estável" },
        { label: "Após lei 6515?", key: "casamentoAposLei6515", type: "boolean", group: "Dados do casamento/união estável" },
        { label: "Data do casamento/união", key: "dataCasamento", type: "date", group: "Dados do casamento/união estável" },
        { label: "Data da Separação", key: "dataSeparacao", type: "date", group: "Dados da separação" },
        { label: "Data da Extinção Conjugal", key: "dataExtincaoConjugal", type: "date", group: "Dados da separação" },
        { label: "Detalhes Regime Separação", key: "detalhesRegimeSeparacao", group: "Dados da separação" },
        { label: "Ex-cônjuge", key: "exConjuge", formatter: async (value) => AuditoriaBusiness.getEntityById(value, IndicadorPessoalBusiness), group: "Dados da separação" },
        { label: "Regime", key: "regimeCasamento", type: "enum", lista: IndicadorPessoalBusiness.getRegimes(), group: "Dados do casamento/união estável" },
        { label: "Detalhes de regime", key: "detalhesRegime", group: "Dados do casamento/união estável" },
        { label: "Adicionar dados de registro do pacto antenupcial?", key: "adicionarRegistroPactoAntenupcial", type: "boolean", group: "Dados do casamento/união estável" },
        { label: "Número do registro", key: "numeroRegistroPactoAntenupcial", group: "Dados do casamento/união estável" },
        { label: "Registro de Imóveis", key: "registroImoveisPactoAntenupcial", group: "Dados do casamento/união estável" }
      );
    }

    formatters.push(
      { label: "Banco", key: "banco", group: "Dados Bancários" },
      { label: "Agência", key: "agencia", group: "Dados Bancários" },
      { label: "Conta", key: "conta", group: "Dados Bancários" }
    );

    if (auditoria.tipoPessoaAntes !== "FISICA" || auditoria.tipoPessoaDepois !== "FISICA") {
      formatters.push(
        { label: "Inscrição estadual", key: "inscricaoEstadual", group: "Dados básicos" },
        { label: "Inscrição municipal", key: "inscricaoMunicipal", group: "Dados básicos" },
        { label: "NIRE", key: "nire", group: "Dados básicos" },
        { label: "Participação estrangeira?", key: "possuiParticipacaoEstrangeira", type: "boolean", group: "Dados básicos" },
        { label: "Natureza Jurídica", key: "naturezaJuridica", type: "enum", lista: IndicadorPessoalBusiness.getNaturezaJuridica(), group: "Dados básicos" },
        { label: "Descrição", key: "naturezaJuridicaOutras", group: "Dados básicos" },
        { label: "Natureza Jurídica ONRTDPJ", key: "naturezaJuridicaOnrtdpj", type: "enum", lista: IndicadorPessoalBusiness.getNaturezaJuridicaOnrtdpj(), group: "Dados básicos" }
      );
    }

    formatters.push(
      { label: "E-mail", key: "email", group: "Contato" },
      { label: "Telefone", key: "telefone", group: "Contato" },
      { label: "Celular", key: "celular", group: "Contato" },
      { label: "Comercial", key: "comercial", group: "Contato" },
      { label: "CEP", key: "cep", group: "Endereço" },
      { label: "Tipo Logradouro", key: "tipoLogradouroItn", group: "Endereço" },
      { label: "Logradouro (rua)", key: "logradouro", group: "Endereço" },
      { label: "Número", key: "numero", group: "Endereço" },
      { label: "Quadra", key: "quadra", group: "Endereço" },
      { label: "Lote", key: "lote", group: "Endereço" },
      { label: "Bairro (setor)", key: "bairro", group: "Endereço" },
      { label: "Cidade", key: "cidade", group: "Endereço" },
      { label: "Estado", key: "estado", type: "enum", lista: EnderecoBusiness.getEstados(), group: "Endereço" },
      { label: "País", key: "pais", type: "enum", lista: IndicadorPessoalBusiness.getNacionalidades(), nomeLista: "pais", group: "Endereço" },
      { label: "Complemento", key: "complemento", group: "Endereço" }
    );

    if (auditoria.tipoPessoaAntes === "FISICA" || auditoria.tipoPessoaDepois === "FISICA") {
      formatters.push(
        { label: "CEP", key: "cepComercial", group: "Endereço comercial" },
        { label: "Tipo Logradouro", key: "tipoLogradouroComercialItn", group: "Endereço comercial" },
        { label: "Logradouro (rua)", key: "logradouroComercial", group: "Endereço comercial" },
        { label: "Número", key: "numeroComercial", group: "Endereço comercial" },
        { label: "Quadra", key: "quadraComercial", group: "Endereço comercial" },
        { label: "Lote", key: "loteComercial", group: "Endereço comercial" },
        { label: "Bairro (setor)", key: "bairroComercial", group: "Endereço comercial" },
        { label: "Cidade", key: "cidadeComercial", group: "Endereço comercial" },
        { label: "Estado", key: "estadoComercial", type: "enum", lista: EnderecoBusiness.getEstados(), group: "Endereço comercial" },
        { label: "País", key: "paisComercial", type: "enum", lista: IndicadorPessoalBusiness.getNacionalidades(), nomeLista: "pais", group: "Endereço comercial" },
        { label: "Complemento", key: "complementoComercial", group: "Endereço comercial" }
      );
    }

    formatters.push({ label: "Observações", key: "observacao", group: "Complemento" });
    return formatters;
  },

  getFormattersIndicadorPessoalSocio() {
    return [
      { label: "Nome", key: "indicadorPessoalSocio.nome", type: "string" },
      { label: "Tipo Vinculo", key: "descricaoTipoVinculo", type: "string" },
      { label: "Descrição", key: "descricao", type: "string" },
      { label: "Inicio", key: "inicio", type: "date" },
      { label: "Fim", key: "fim", type: "date" },
      { label: "Periodo Desconhecido", key: "periodoDesconhecido", type: "boolean" },
      { label: "Possui a maioria do capital social", key: "maioriaCapitalSocial", type: "boolean" }
    ];
  },

  getFormattersProtocolo(dominio) {
    const camposOcultosParaTN = DominioBusiness.isDominioEspecificoNotas(dominio)
      ? ['vencimento', 'prazoQualificacao', 'cancelamentoAutomatico', 'dto.camposAdicionais.TIPO_REGISTRO', 'tipoRegistro', 'tomadorNaoInformado']
      : [];

    const formatters = [
      { label: "Código", key: "codigo", type: "integer" },
      { label: "Letra", key: "letra", type: "text" },
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Registro", key: "registro", type: "datetime" },
      { label: "Selado", key: "selado", type: "datetime" },
      { label: "Vencimento Prenotação", key: "vencimento", type: "datetime-date" },
      { label: "Reingresso", key: "reingresso", type: "date" },
      { label: "Vencimento Após Reingresso", key: "prazoPosReingresso", type: "date" },
      { label: "Prazo de Qualificação", key: "prazoQualificacao", type: "date", show: () => DominioBusiness.isProtocolo(dominio) },
      { label: "Data Base de Cálculo", key: "dataBase", type: "date" },
      { label: "Livro do Título", key: "livro", type: "text" },
      { label: "Folha do Título", key: "folha", type: "text" },
      { label: "Tags", key: "tags", type: "listahtml" },
      { label: "E-mail", key: "emails", type: "listahtml" },
      { label: "Senha", key: "senha", type: "text", show: () => !DominioBusiness.isServico(dominio) },

      //E-Intimação Central
      { label: "Protocolo E-Intimação", key: "protocoloEintimacao", type: "text" },
      { label: "Número do Contrato", key: "numeroContrato", type: "text" },
      { label: "DV do Contrato", key: "numeroContratoDv", type: "text" },

      { label: "Estados", key: "estado", type: "enum", lista: EnderecoBusiness.getEstados() },
      { label: "Número De Controle Externo", key: "numeroControleExterno", type: "string" },

      { label: "Custa Diferida", key: "diferido", type: "boolean", group: "Emolumentos & Base de Cálculo" },
      { label: "Motivo Diferimento", key: "motivoDiferimento", type: "enum", group: "Emolumentos & Base de Cálculo", lista: RegraCustasBusiness.getMotivosIsencao(VueBusiness.getVueRoot().config.estado) },
      { label: "Tipo de Registro", key: "dto.camposAdicionais.TIPO_REGISTRO", type: "enum", lista: TabelaCustaBusiness.listTiposRegistro(), show: () => !DominioBusiness.isServico(dominio) },
      { label: "Tipo Registro", key: "tipoRegistro", type: "enum", lista: TabelaCustaBusiness.listTiposRegistro(), group: "Emolumentos & Base de Cálculo", show: () => !DominioBusiness.isServico(dominio) },
      { label: "Isento", key: "isento", type: "boolean", group: "Emolumentos & Base de Cálculo" },

      { label: "Serviço Principal", key: "tipoServico", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoServicoBusiness) },
      { label: "Natureza", key: "natureza", formatter: (value) => AuditoriaBusiness.getEntityById(value, NaturezaBusiness) },

      { label: "Prioridade", key: "prioridade", type: "enum", lista: ProtocoloBusiness.getPrioridades(), show: () => !DominioBusiness.isServico(dominio) },
      { label: "Tipo de Suspensão", key: "cancelamentoAutomatico", type: "enum", lista: ProtocoloBusiness.getTipoCancelamentoAutomatico(), show: () => !DominioBusiness.isServico(dominio) },

      { label: "Solicitante", key: "solicitante", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },
      { label: "Interessado", key: "interessado", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value), show: () => !DominioBusiness.isServico(dominio) },
      { label: "Tomador", key: "tomador", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },
      { label: "Outorgante", key: "outorgante", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },
      { label: "Outorgado", key: "outorgado", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },
      { label: "Tomador não informado?", key: "tomadorNaoInformado", type: "boolean", show: () => !DominioBusiness.isServico(dominio) },
      { label: "Finalidade", key: "finalidade", type: "string" },

      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Índices", key: "indices", type: "checklist", group: "Checklist" },
      { label: "Exigências", key: "exigencias", type: "listaHtml", group: "Exigências" },
      { label: "Indisponibilidade", key: "indisponibilidadeOrdem", type: "detalhes-indisponibilidade" },
      { label: "Vínculos", key: "vinculos", formatter: (value) => AuditoriaBusiness.getVinculos(value) },

      {
        label: "Situação (Asgard)",
        key: "situacao",
        type: "enum",
        lista: [
          { id: "DEFERIDA", nome: "Deferida" },
          { id: "INDEFERIDA", nome: "Indeferida" },
          { id: "EM_ANALISE", nome: "Em Análise" }
        ],
        show: (dados) => dados?.protocoloRedesim !== undefined
      }
    ];

    return formatters.filter(f => !camposOcultosParaTN.includes(f.key));
  },

  getFormattersProtocoloDocumento() {
    return [
      { label: "Protocolo", key: "protocolo", formatter: (value) => AuditoriaBusiness.nomearProtocolo(value) },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Nome", key: "nome", type: "string" },
      { label: "Tipo de Documento", key: "tipoDocumento", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoDocumentoBusiness) },
      { label: "Índices", key: "indices", type: "checklist", group: "Checklist" },
      { label: "Exigências", key: "exigencias", type: "listaHtml", group: "Exigências" }
    ];
  },

  getFormattersLivroProtocolo() {
    return [
      { label: "Ordem", key: "ordem", type: "integer" },
      { label: "Data", key: "dia", type: "date" },
      { label: "Tipo", key: "tipo", type: "enum", lista: ProtocoloBusiness.getTiposOcorrencia() },
      { label: "Anotação", key: "anotacao", type: "string" },
      { label: "Natureza", key: "natureza", type: "string" },
      { label: "Interessado", key: "solicitante", type: "string" },
      { label: "Hora", key: "hora", type: "string" },
      { label: "Hash", key: "hash", type: "string" },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getEntityById(value, UsuarioBusiness) }
    ];
  },

  getFormattersProtocoloRepasse() {
    return [
      { label: "Protocolo", key: "protocolo", formatter: (value) => AuditoriaBusiness.nomearProtocolo(value) },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Repasse", key: "repasse", formatter: (value) => AuditoriaBusiness.getEntityById(value, RepasseBusiness) },
      { label: "Descrição", key: "descricao", type: "string" },
      { label: "Confirmado", key: "confirmado", type: "boolean" },
      { label: "Confirmação", key: "confirmacao", type: "datetime" }
    ];
  },

  getFormattersRegistroAuxiliar(auditoria) {
    let tipoRegistro = auditoria?.antes?.tipoRegistro || auditoria?.depois?.tipoRegistro;
    let labelTexto = tipoRegistro === "CEDULA" ? "Garantia" : "Teor";

    return [
      { label: "CNM", key: "cnm" },
      { label: "Tipo de Registro Auxiliar", key: "tipoRegistro", type: "enum", lista: RegistroAuxiliarBusiness.getTipos() },
      { label: "Tipo de Cédula", key: "tipoCedula", type: "enum", lista: RegistroAuxiliarBusiness.getTiposCedulas() },
      { label: "Nome do Condomínio", key: "condominio" },
      { label: "Data do Pacto", key: "pacto", type: "date" },
      { label: "Último Ato", key: "ultimoAto" },
      { label: "Situação", key: "status", type: "enum", lista: RegistroAuxiliarBusiness.getStatusImovel(false) },
      { label: "Abertura", key: "abertura", type: "datetime" },
      { label: "Cancelamento/Encerramento", key: "encerramento", type: "datetime" },
      { label: "Vencimento", key: "vencimentoCedula", type: "date" },
      { label: "Valor", key: "valorCedula", type: "currency" },
      { label: labelTexto, key: "texto" },
      {label: "Texto Importado", key: "textoLegado"},
      {label: "Observações", key: "observacoes"},
      {label: "Safra Ano Inicial", key: "safraAnoInicial"},
      {label: "Safra Ano Final", key: "safraAnoFinal"},
      {label: "Quantidade", key: "quantidade"},
      {label: "Número do Titulo", key: "numeroTitulo"},
      {label: "Unidade de Medida", key: "unidadeMedida"},
      {label: "Tipo de Produto", key: "tipoProduto"},
      {label: "Área Plantada", key: "areaPlantada"},
      {label: "Grau", key: "grau"},
      {label: "Livro (Letra)", key: "livroLetra"},
    ];
  },

  getFormattersProtocoloAtividade() {
    return [
      { label: "Exigência", key: "exigencias", type: "listahtml" }
    ];
  },

  async getFormattersProtocoloFinanceiro(auditoria) {
    return await AuditoriaBusiness.formattersFinanceiro({ auditoria });
  },

  getFormattersNotaFiscal() {
    return [
      { label: "RPS", key: "rps" },
      { label: "Série RPS", key: "serieRps" },
      { label: "Número da Nota", key: "nfseNumero" },
      { label: "Código de Verificação", key: "nfseCodigoVerificacao" },
      { label: "URL PDF Prefeitura", key: "urlPdfPrefeitura" },
      { label: "Data de Emissão", key: "emissao", type: "datetime" },
      { label: "Competência", key: "competencia", type: "datetime" },
      { label: "Data de Envio", key: "envio", type: "datetime" },
      { label: "Data de Cancelamento", key: "cancelamento", type: "datetime" },
      { label: "Valor Total", key: "total", type: "currency" },
      { label: "Dedução", key: "deducao", type: "currency" },
      { label: "ISS", key: "iss", type: "currency" },
      { label: "Situação", key: "status", type: "enum", lista: NotaFiscalBusiness.getSituacaoNota() },
      { label: "Situação Anterior", key: "statusAnterior", type: "enum", lista: NotaFiscalBusiness.getSituacaoNota() },
      { label: "Emissão Manual", key: "emissaoManual", type: "boolean" },
      { label: "Protocolo", key: "protocolo" },
      { label: "Discriminação", key: "discriminacao" },
      { label: "Tomador", key: "nomeTomador" }
    ];
  },

  getFormattersProtocoloFinanceiroAjuste() {
    let formatters = [
      { label: "Descrição", key: "descricao", type: "text" },
      { label: "Data Negativo", key: "dataAjusteNegativo", type: "date" },
      { label: "Data Positivo", key: "dataAjustePositivo", type: "date" },
      { label: "Emolumentos", key: "emolumentos", type: "currency" }
    ];

    if (VueBusiness.getVueRoot().isEstadoSC) {
      formatters.push(
        { label: "ISS", key: "iss", type: "currency" },
        { label: "FRJ", key: "frj", type: "currency" }
      );
    }

    return formatters;
  },

  getFormattersNotificacao() {
    return [
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Tipo", key: "atribuicao", type: "string" },
      { label: "Tipo de Notificação", key: "tipoServico", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoServicoBusiness) },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Resultado Final", key: "resultadoFinal", type: "enum", lista: NotificacaoBusiness.getResultadosNotificacao() },
      { label: "Observações", key: "observacoes", type: "string" },
      { label: "Envolvidos", key: "envolvidos", type: "string", formatter: (value) => AuditoriaBusiness.envolvidos({ envolvidos: value }) },
      { label: "Endereços", key: "enderecos", type: "string", formatter: (value) => AuditoriaBusiness.enderecos(value) },
      { label: "Protocolos Relacionados", key: "protocolos", type: "string", formatter: (value) => AuditoriaBusiness.protocolos(value) },
      { label: "Registro RTD Relacionado", key: "registrosTds", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value, "registroTitulo") },
      { label: "Matrículas Relacionadas", key: "matriculas", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value) },
      { label: "Indicadores Reais Externos Relacionados", key: "matriculasExternas", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value, "indicadorRealExterno") },
      { label: "Índices", key: "indices", type: "checklist", group: "Checklist" },
      { label: "Texto", key: "texto", type: "string" },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getUsuario(value) }
    ];
  },

  getFormattersOcorrencia() {
    return [
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Data da Ocorrência", key: "dataOcorrencia", type: "date" },
      { label: "Tipo de Ocorrência", key: "tipoServico", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoServicoBusiness) },
      { label: "Data da Ocorrência", key: "data", type: "date" },
      { label: "Descrição", key: "descricao", type: "string" },
      { label: "Matrículas Relacionadas", key: "matriculas", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value) },
      { label: "Registros Auxiliares Relacionados", key: "registrosAuxiliares", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value, "registroAuxiliar") },
      { label: "Protocolos Relacionados", key: "protocolos", type: "string", formatter: (value) => AuditoriaBusiness.protocolos(value) },
      { label: "Envolvidos", key: "envolvidos", type: "string", formatter: (value) => AuditoriaBusiness.envolvidos({ envolvidos: value, notificacao: true, ocorrencia: true }) },
      { label: "Número do Processo", key: "processo", type: "string" },
      { label: "Data do Processo", key: "dataProcesso", type: "date" },
      { label: "Juiz", key: "juiz", type: "string" },
      { label: "Vara", key: "vara", type: "string" },
      { label: "Ocorrência", key: "ocorrencia", type: "string" },
      { label: "Observações", key: "observacoes", type: "string" },
      { label: "Informações", key: "informacoes", type: "string" },
      { label: "Índices", key: "indices", type: "checklist", group: "Checklist" },
      { label: "Data do Reingresso", key: "dataReingresso", type: "date" },
      { label: "Encerramento", key: "encerramento", type: "date" },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getUsuario(value) }
    ];
  },

  getFormattersOficio() {
    return [
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Prazo para Resposta", key: "vencimento", type: "date" },
      { label: "Tipo de Ofício", key: "tipoServico", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoServicoBusiness) },
      { label: "Tipo", key: "tipo", type: "string" },
      { label: "Ofício de Origem", key: "anterior", formatter: (value) => this.getAnterior(value) },
      { label: "Matrículas Relacionadas", key: "matriculas", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value) },
      { label: "Registros Auxiliares Relacionados", key: "registrosAuxiliares", type: "string", formatter: (value) => AuditoriaBusiness.matriculas(value, "registroAuxiliar") },
      { label: "Protocolos Relacionados", key: "protocolos", type: "string", formatter: (value) => AuditoriaBusiness.protocolos(value) },
      { label: "Envolvidos", key: "envolvidos", type: "string", formatter: (value) => AuditoriaBusiness.envolvidos({ envolvidos: value }) },
      { label: "Número do processo", key: "processo", type: "string" },
      { label: "Número do ofício", key: "oficio", type: "string" },
      { label: "Vara", key: "vara", type: "string" },
      { label: "Remetente", key: "remetente", type: "string" },
      { label: "Destinatário", key: "destinatario", type: "string" },
      { label: "Observações", key: "observacoes", type: "string" },
      { label: "Índices", key: "indices", type: "checklist", group: "Checklist" },
      { label: "Texto", key: "texto", type: "string" },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getUsuario(value) }
    ];
  },

  async getFormattersAtos(auditoria) {
    return await AuditoriaBusiness.formattersAtos(auditoria);
  },

  getFormattersLancamento() {
    return [
      { label: "Fornecedor", key: "nomeFornecedor", type: "string" },
      { label: "Descrição", key: "descricao" },
      { label: "Tipo de documento", key: "tipoDocumento", type: "enum", lista: CategoriaBusiness.tiposDocumentos },
      { label: "Número do documento fiscal", key: "numeroDocumentoFiscal" },
      { label: "Nº de Aut. Prévia", key: "numeroAutorizacaoPrevia" },
      { label: "Categoria", key: "categoria", type: "json" },
      { label: "Data Competência", key: "competencia", type: "date" },
      { label: "Valor", key: "valor", type: "currency" },
      { label: "ISS", key: "issRepassado", type: "currency" },
      { label: "Data de vencimento", key: "vencimento", type: "date" },
      { label: "Caixa", key: "caixa", type: "json" },
      { label: "Data de pagamento", key: "pagamento", type: "date" },
      { label: "Lançamento recorrente", key: "lancamentoRecorrente", type: "boolean" },
      { label: "Conciliado", key: "conciliado", type: "boolean" },
      { label: "Período recorrência", key: "periodoRecorrencia", type: "enum", lista: [{ id: "MESES", nome: "Meses" }, { id: "DIAS", nome: "Dias" }] },
      { label: "Quantidade recorrência", key: "quantidadeRecorrencia" },
      { label: "Pagamento realizado com cheque", key: "pagamentoComCheque", type: "boolean" },
      { label: "Número de Controle", key: "numeroControle" },
      { label: "Observação", key: "observacao" },
      { label: "Ordem", key: "ordem", type: "string" },
      { label: "Nome", key: "nomeAnexo", type: "string" },
      { label: "Caminho", key: "caminho", type: "string" },
      { label: "Tags", key: "tags", type: "listahtml" },
      { label: "Caminho Assinado", key: "caminhoAssinado", type: "string" }
    ];
  },

  getFormattersReceitaExternaItem() {
    return [
      { label: "Data", key: "data", type: "date" },
      { label: "Código do Ato", key: "codigoAto" },
      { label: "Histórico", key: "historico" },
      { label: "Quantidade", key: "quantidade" },
      { label: "Valor Total", key: "valorTotal", type: "currency" },
    ];
  },

  getFormattersSelo() {
    return [
      { label: "Código do Selo", key: "codigo", type: "string" },
      { label: "Situação", key: "status", type: "string" },
      { label: "Motivo Cancelamento", key: "motivoCancelamento", type: "string" },
      { label: "Enviado", key: "enviado", type: "boolean" },
      { label: "Data de Utilização", key: "utilizacao", type: "datetime" },
      { label: "Data de Envio", key: "envio", type: "datetime" },
      { label: "Selo Pai", key: "codigoPai", type: "string" },
      { label: "Usuário Utilização", key: "usuario", formatter: (value) => AuditoriaBusiness.getUsuario(value) },
      { label: "Usuário Cancelamento", key: "usuarioCancelamento", formatter: (value) => AuditoriaBusiness.usuarioLogado(value) },
      { label: "Protocolo", key: "protocolo", formatter: (value) => AuditoriaBusiness.nomearProtocolo(value) },
      { label: "Ato", key: "ato", formatter: (value) => AuditoriaBusiness.getTipoAto(value) },
      { label: "Certidao", key: "certidao", formatter: (value) => AuditoriaBusiness.nomearCertidao(value) },
      { label: "Prenotação", key: "protocoloPrenotacao", formatter: (value) => AuditoriaBusiness.nomearPrenotacao(value) },
      { label: "Custa Adicional", key: "protocoloCustaAdicional", formatter: (value) => AuditoriaBusiness.nomearCustaAdicional(value) },
      { label: "Folha", key: "folha", type: "string" },
      { label: "Número Ordem", key: "numeroOrdem", type: "string" },
      { label: "XML Retificado", key: "xmlRetificado", type: "string" },
      { label: "Data de Solicitação de Retificação", key: "solicitacaoRetificacao", type: "datetime" }
    ];
  },

  getFormattersLoteEnvioSelo() {
    return [
      { label: "Arquivo", key: "arquivo", type: "string" },
      { label: "XML Gerado", key: "xml", type: "download-xml" },
    ];
  },

  getFormattersSiscoaf() {
    return [
      { label: "Início do fato", key: "inicio", type: "date" },
      { label: "Fim do fato", key: "fim", type: "date" },
      { label: "Valor da operação", key: "valor", type: "currency" },
      { label: "Cidade", key: "cidade" },
      { label: "Estado", key: "estado", type: "enum", lista: EnderecoBusiness.getEstados() },
      { label: "Envolvidos", key: "envolvidos", type: "string", formatter: (value) => AuditoriaBusiness.envolvidosSiscoaf(value) },
      { label: "Ocorrências", key: "ocorrencias", type: "listahtml" },
      { label: "Informações Adicionais", key: "descricao", type: "string" },
      { label: "Status", key: "status", type: "enum", lista: SiscoafBusiness.status() },
      { label: "Código do Recibo", key: "codigoCoaf", type: "string" }
    ];
  },

  getFormattersDaje() {
    return [
      { label: "Número da Guia", key: "numeroControle" },
      { label: "Atribuição", key: "requisicao.atribuicao" },
      { label: "DAJE Complementar", key: "requisicao.complementar", type: "boolean" },
      { label: "Referência", key: "requisicao.dajePrincipal" },
      { label: "Isento", key: "requisicao.isento", type: "boolean" },
      { label: "Gratuito", key: "requisicao.gratuito", type: "boolean" },
      { label: "Valor", key: "valor", type: "currency" },
      { label: "Tipo do Ato", key: "requisicao.codigoTipoAto" },
      { label: "Quantidade", key: "requisicao.quantidade" },
      { label: "Nota de Desconto/Acréscimo", key: "requisicao.codigoNota" },
      { label: "Contribuinte", key: "requisicao.contribuinte" },
      { label: "Endereço", key: "requisicao.endereco" },
      { label: "Cidade", key: "requisicao.cidade" },
      { label: "CPF/CNPJ", key: "requisicao.documento" },
      { label: "Observação", key: "requisicao.observacao" }
    ];
  },

  getFormattersIndisponibilidade() {
    return [
      { label: "Nome", key: "nome", type: "string" },
      { label: "Documento", key: "documento", type: "string" },
      { label: 'Indicador Real', key: 'indicadorReal', formatter: (value) => AuditoriaBusiness.nomearFicha(value)},
      { label: "Indicador Pessoal", key: "indicadorPessoal", formatter: (value) => AuditoriaBusiness.indicadorPessoal(value) },

      { label: "Cancelado", key: "cancelado", type: "boolean" },
      { label: "Motivo Cancelamento", key: "motivoCancelamento", type: "string" },
      { label: "Cancelamento", key: "cancelamento", type: "datetime" },
      { label: "Usuário Cancelamento", key: "usuarioCancelamento", formatter: (value) => AuditoriaBusiness.usuarioLogado(value) },
    ];
  },

  getFormattersRegistroTD() {
    return [
      { label: "Tipo de Registro", key: "tipoRegistro", type: "enum", lista: [...RegistroTDBusiness.getTipos(), ...RegistroPJBusiness.getTipos()] },
      { label: "Último Ato", key: "ultimoAto" },
      { label: "Situação", key: "status", type: "enum", lista: RegistroTDBusiness.getStatusImovel(false) },
      { label: "Abertura", key: "abertura", type: "datetime" },
      { label: "Cancelamento/Encerramento", key: "encerramento", type: "datetime" },
      { label: "Texto Importado", key: "textoLegado" },
      { label: "Observações", key: "observacoes" },
      { label: "Livro (Letra)", key: "livroLetra" },
      { label: "Tipo", key: "tipoBem", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoBemBusiness) },
      { label: "Nome", key: "nome" },
      { label: "Identificação", key: "identificacao" },
      { label: "Fabricante", key: "fabricante" },
      { label: "Data de Referência", key: "dataReferencia", type: "date" },
      { label: "Localização", key: "localizacao" },
      { label: "Valor", key: "valor", type: "currency" },
      { label: "Nota fiscal", key: "notaFiscal" },
      { label: "Detalhes", key: "detalhes" },
      {
        label: "Registro Anterior",
        key: "origem",
        formatter: async (value) => {
          if (!value) return null;
          let indicador = await IndicadorAbstractService.getById(value).catch(e => {});
          let ficha = FrontBusiness.nomearFicha(indicador);
          return `${ficha} - ${indicador.tipoRegistroString}`;
        }
      }
    ];
  },

  getFormattersInconformidade() {
    return [
      { label: "Descrição", key: "descricao", type: "string" },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Tipo de Inconformidade", key: "tipoInconformidade", formatter: (value) => AuditoriaBusiness.getEntityById(value, TipoInconformidadeBusiness) },
      { label: "Data Inconformidade", key: "dataInconformidade", type: "date" },
      { label: "Análise da Causa", key: "analiseCausa", type: "html" },
      { label: "Plano de Ação", key: "planoAcao", type: "html" }
    ];
  },

  getCamposAnexo() {
    return [
      { label: "Ordem", key: "ordem", type: "string" },
      { label: "Nome", key: "nomeAnexo", type: "string" },
      { label: "Caminho", key: "caminho", type: "string" },
      { label: "Tags", key: "tags", type: "listahtml" },
      { label: "Caminho Assinado", key: "caminhoAssinado", type: "string" },
      { label: "Paginas", key: "totalPagina", type: "string" },
      { label: "Etiquetas", key: "etiquetas", type: "string", formatter: async (value) => await AuditoriaBusiness.formattersEtiqueta(value) }
    ];
  },

  getFormattersArquivoMortoPasta() {
    return [
      { label: "Nome", key: "nome", type: "string" },
      { label: "Registro Ativo", key: "ativo", type: "boolean" }
    ];
  },

  getCamposArquivoMorto() {
    return [
      { label: "Nome", key: "nome", type: "string" },
      { label: "Pasta", key: "pasta", type: "string" }
    ];
  },

  getCamposAnotacao() {
    return [
      { label: "Protocolo", key: "protocolo", formatter: (value) => AuditoriaBusiness.nomearProtocolo(value) },
      { label: "Etapa", key: "etapa", formatter: (value) => AuditoriaBusiness.getEntityById(value, EtapaBusiness) },
      { label: "Cadastro", key: "cadastro", type: "datetime" },
      { label: "Anotação", key: "anotacao", type: "string" },
      { label: "Exibir no Site", key: "exibirSite", type: "boolean" },
      { label: "Sinalizar", key: "sinalizada", type: "boolean" },
      { label: "Usuário", key: "usuario", formatter: (value) => AuditoriaBusiness.getUsuario(value) }
    ];
  },

  getCamposEnvioEmail() {
    return [
      { label: "Protocolo", key: "protocolo", formatter: (value) => AuditoriaBusiness.nomearProtocolo(value) },
      { label: "Email", key: "destino" },
      { label: "Assunto", key: "assunto" },
      { label: "Mensagem", key: "mensagem", type: "string" }
    ];
  },

  getFormattersSenhaAtendimento() {
    return [
      { label: "Encerramento", key: "encerramento", type: "time" }
    ];
  },

  getFormattersDocumentacao() {
    return [
      { label: "Tipo", key: "tipo", type: "enum", lista: DocumentacaoBusiness.tipos() },
      { label: "Vencimento", key: "vencimento", type: "date" },
      { label: "Registro Ativo", key: "ativo", type: "boolean" },
      { label: "Nº Ordem", key: "numero", type: "string" },
      { label: "Livro", key: "livro", type: "string" },
      { label: "Folha Inicial", key: "folhaInicial", type: "string" },
      { label: "Folha Final", key: "folhaFinal", type: "string" },
      { label: "Folha", key: "folha", type: "string", show: (row) => row?.folha != null && row?.folhaInicial == null },
      { label: "Espécie", key: "especie", type: "string" },
      { label: "Serventia", key: "serventia", type: "string" },
      { label: "Instituição", key: "instituicao", type: "string" },
      { label: "Lavratura", key: "lavratura", type: "date" },
      { label: "Nº Registro", key: "numeroRegistro", type: "string" },
      { label: "Data Registro", key: "registro", type: "date" },
      { label: "Data de Arquivamento", key: "arquivamento", type: "date" },
      { label: "Observação", key: "descricao", type: "string" },
      { label: "Envolvidos", key: "envolvidos", type: "string", formatter: (value) => AuditoriaBusiness.envolvidos({ envolvidos: value, documentacao: true }) },
      { label: "Documentações Relacionadas", key: "documentacoes", type: "string", formatter: (value) => AuditoriaBusiness.documentacoes(value) },
      { label: "Protocolos Relacionados", key: "protocolos", type: "string", formatter: (value) => AuditoriaBusiness.protocolos(value) },

    ];
  },

  getFormattersSaseCe() {
    return [
      { label: "Data", key: "competencia", type: "date" },

      { label: "Cód. Ato", key: "codigoAto", type: "integer" },
      { label: "Cód. Selo", key: "codigoSelo", type: "integer" },
      { label: "Quantidade", key: "quantidade", type: "integer" },

      { label: "ISS", key: "iss", type: "currency" },
      { label: "Selo", key: "selo", type: "currency" },
      { label: "FRMMP", key: "frmmp", type: "currency" },
      { label: "FAADEP", key: "faadep", type: "currency" },
      { label: "FERMOJU", key: "fermoju", type: "currency" },
      { label: "Emolumentos", key: "emolumentos", type: "currency" },
      { label: "Total", key: "totalSase", type: "currency" },

      { label: "Total ISS", key: "totalIss", type: "currency", group: "Total" },
      { label: "Total Selo", key: "totalSelo", type: "currency", group: "Total" },
      { label: "Total FRMMP", key: "totalFrmmp", type: "currency", group: "Total" },
      { label: "Total FAADEP", key: "totalFaadep", type: "currency", group: "Total" },
      { label: "Total FERMOJU", key: "totalFermoju", type: "currency", group: "Total" },
      { label: "Total Emolumentos", key: "totalEmolumentos", type: "currency", group: "Total" },
      { label: "Total Geral", key: "totalGeral", type: "currency", group: "Total" }
    ];
  },

  getFormattersSaseCeDeclarados() {
    return [
      { label: "Quantidade de registros alterados", key: "quantidadeRegistrosAlterados", type: "integer" }
    ];
  },

  // ==============
  // Natureza
  // ==============

  getFormattersNaturezaDominioPersonalizado() {
    return [
      ...this.default,
      { label: "Ordem", key: "ordem" },
      { label: "Validade Legal", key: "validade", group: "Prenotação" },
      { label: "Usar dias corridos?", key: "diasCorridos", type: "boolean", group: "Prenotação" },
      { label: "Calcular a partir da entrada?", key: "hoje", type: "boolean", group: "Prenotação" }
    ];
  },

  getFormattersNatureza() {
    return [
      ...this.default,
      { label: "Ordem", key: "ordem" },
      { label: "Natureza Título DOI", key: "naturezaDoi", group: "Prenotação", type: "enum", lista: ProtocoloBusiness.getNaturezasDOI() },
      { label: "Espécie", key: "especie", group: "Prenotação", type: "enum", lista: [{id: 'NOTAS', nome: 'Notas'}, {id: 'OUTROS', nome: 'Outros'}] },
      { label: "Validade Legal", key: "validade", group: "Prenotação" },
      { label: "Usar dias corridos?", key: "diasCorridos", type: "boolean", group: "Prenotação" },
      { label: "Calcular a partir da entrada?", key: "hoje", type: "boolean", group: "Prenotação" },
      { label: "Prazo", key: "qualificacao", group: "Qualificação" },
      { label: "Usar dias corridos?", key: "diasCorridosQualificacao", type: "boolean", group: "Qualificação" },
      { label: "Calcular a partir da entrada?", key: "hojeQualificacao", type: "boolean", group: "Qualificação" },
      { label: "Prazo", key: "reingresso", group: "Reingresso" },
      { label: "Usar dias corridos?", key: "diasCorridosReingresso", type: "boolean", group: "Reingresso" },
      { label: "Calcular a partir da entrada?", key: "hojeReingresso", type: "boolean", group: "Reingresso" },
      { label: "Alterar vencimento da prenotação no reingresso?", key: "alterarVencimentoReingresso", type: "boolean", group: "Reingresso" },
      { label: "Considerar vencimento original como data mínima no reingresso?", key: "respeitarVencimentoReingresso", type: "boolean", group: "Reingresso" },
      { label: "Alterar o prazo de qualificação?", key: "alterarQualificacaoReingresso", type: "boolean", group: "Reingresso" },
      { label: "Prazo de Qualificação no Reingresso?", key: "qualificacaoReingresso", group: "Reingresso" },
      { label: "Alterar vencimento ao entrar na etapa?", key: "alterarVencimentoPagamento", type: "boolean", group: "Aguardando Pagamento" },
      { label: "Permitir reduzir a data de vencimento da prenotação?", key: "permitirReduzirVencimentoPagamento", type: "boolean", group: "Aguardando Pagamento" },
      { label: "Alterar o prazo de qualificação?", key: "alterarQualificacaoPagamento", type: "boolean", group: "Aguardando Pagamento" },
      { label: "Prazo de Qualificação no Reingresso?", key: "qualificacaoPagamento", group: "Aguardando Pagamento" },
      { label: "Tipo de protocolo", key: "tiposProtocolo", type: "listaEnum", lista: ProtocoloBusiness.getTiposProtocolo() },
      { label: "Documentos", key: "documentos", formatter: (value) => AuditoriaBusiness.documentos(value) },
      { label: "Permitir criar Ocorrências através do protocolo?", key: "permitirCriarOcorrencias", type: "boolean" },
      { label: "Permitir criar Ofícios através do protocolo?", key: "permitirCriarOficios", type: "boolean" },
      { label: "Permitir criar Notificações através do protocolo?", key: "permitirCriarNotificacoes", type: "boolean" },
      { label: "Tipo do Ato ONRTDPJ", key: "tipoAtoRcpjOnrtdpj", type: "enum", lista: [
        {id: 'CONSTITUICAO', nome: '1 - Constituição'},
        {id: 'ALTERACAO', nome: '2 - Alteração'},
        {id: 'EXTINCAO', nome: '3 - Extinção'},
      ]},

    ];
  },

  async getAnterior(id) {
    if (!Utils.testUUID(id))
      return '-';
    let retorno = await OficioBusiness.getById(id);
    return retorno?.id ? `Ofício ${this.tipo(retorno.tipo)} ${retorno.numero}/${retorno.ano}` : '-';
  },

  tipo(tipo){
    let tipos = OficioBusiness.getTipos();
    return FrontBusiness.getLabel(tipo, tipos);
  },

};
